import { useAuth } from "./useAuth";

export const useProtectRoute = (
    origin: string,
    onRedirect: (params: URLSearchParams) => void,
): boolean => {
    const auth = useAuth();

    if (!auth.user || !auth.token) {
        const params = new URLSearchParams({
            origin,
        });
        onRedirect(params);
        return false;
    }

    return true;
};
